import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import carImage from '../../assets/images/car.png';

export function EsqueceuSenha() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      await resetPassword(email);
      
      setMessage({
        type: 'success',
        text: 'Enviamos um link para redefinição de senha no seu e-mail. Por favor, verifique sua caixa de entrada.'
      });
    } catch (error: any) {
      setMessage({
        type: 'error',
        text: error.message === 'Usuário não encontrado'
          ? 'E-mail não encontrado no sistema.'
          : 'Ocorreu um erro ao enviar o e-mail de redefinição. Tente novamente.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <img src={carImage} alt="Automóvel" className="mx-auto mb-4" />
          <h1 className="text-1xl font-bold text-gray-800 mb-2">Recuperação de Senha</h1>
          <p className="text-gray-600">Informe seu e-mail para receber um link de redefinição</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {message && (
            <div className={`p-3 rounded-md text-sm ${
              message.type === 'success' 
                ? 'bg-green-50 text-green-600' 
                : 'bg-red-50 text-red-500'
            }`}>
              {message.text}
            </div>
          )}

          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Seu e-mail cadastrado"
            icon={<Mail className="w-5 h-5" />}
            required
          />

          <Button
            type="submit"
            disabled={loading}
            isLoading={loading}
            className="w-full"
          >
            Enviar Link de Recuperação
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          <Link to="/" className="text-blue-600 hover:text-blue-500 font-medium">
            Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
} 